import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid2, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/store/StoreContext';
import StepContainer from './components/step-container';
import {Filter} from "bad-words";

const filter = new Filter();

export class Questionaries {
  questions: Question[];
  other: string;
  

  constructor(questions: Question[], other: string) {
    this.questions = questions;
    this.other = other;
    
  }
}

interface Question{
    question : string;
    answer: string;
}

const questionSchema = {
  question : yup.string(),
  answer: yup.string().required(),
};


const schema = yup.object().shape({
  questions: yup.array().of(yup.object().shape(questionSchema)),
  other: yup.string().required().test('is-not-profane', 'Profanity is not allowed', value => !filter.isProfane(value || '')),

});


const serviceNoteMap: Record<string, string> = {
  doctorconsultations: "Please mention your symptoms or reason for consultation.",
  onlinemedicalcertificate: "Mention the purpose of the certificate (e.g., sick leave, fitness).",
  onlineprescription: "List any ongoing medications or new symptoms.",
  radiologyreferrals: "Mention the type of scan needed and relevant body part.",
  specialistdoctorreferrals: "Specify the type of specialist you are seeking.",
  pathologyreferrals: "Mention the type of tests or symptoms you are experiencing.",
};



const Questionary = observer(() => {
  const service = useStore()?.service;
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: service?.questionaries
  });

  const onSubmit = (data: any) => {
    service?.updateQuestionaries(data);
  };
const currentServiceType = service?.service?.title?.toLowerCase().replace(/\s+/g, '').trim();
const dynamicNote = currentServiceType && serviceNoteMap[currentServiceType] ? serviceNoteMap[currentServiceType] : '';





  return (
    <form onSubmit={handleSubmit(onSubmit)}>
        <StepContainer 
          icon='fluent-color:chat-bubbles-question-16' 
          title='Answer the Questions'
          cancelButtonProps={{disabled: service?.contentLoading}}
          confirmButtonProps={{type:'submit', disabled: service?.contentLoading,loading: service?.contentLoading}}>
              <Grid2 container spacing={2}>
              {/* <Grid2 size={{xs:12,md:6}}>
                      <Controller
                       name={'irn'}
                       control={control}
                       render={({ field, fieldState: { error } }) => (
                        <>
                          <FormControl fullWidth size='small' margin='dense' error={!!error}>
                            <FormLabel>
  IRN Number <span style={{ color: 'red' }}>*</span>
</FormLabel>

                            <Select
                              {...field}
                              displayEmpty
                              fullWidth
                              value={field.value || ''}
                              error={!!error}
                            >
                              <MenuItem value="">
                                <em>Select IRN Number</em>
                              </MenuItem>
                              {[...Array(12)].map((_, i) => (
                                <MenuItem key={i} value={(i + 1).toString()}>
                                  {i + 1}
                                </MenuItem>
                              ))}
                            </Select>
                            {error && <FormHelperText>{error?.message}</FormHelperText>}
                          </FormControl>
                        </>
                       )}/>
                  </Grid2> */}
                {service?.service?.questions?.split('|').map((question: any, idx: any) => (
                  <Grid2 key={idx} size={12}>
                  <FormControl error={!!errors.questions?.[idx]?.answer}>
                   <FormLabel>
        {question} <span style={{ color: 'red' }}>*</span>
      </FormLabel>
                  <Controller
                  name={`questions.${idx}.answer`}
                  control={control}
                  render={({ field, fieldState }) => (
                  <RadioGroup
                  row
                  {...field}
                  value={field.value || ''}
                  >
                  <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                  )}
                  />
                  {errors.questions?.[idx]?.answer && (
                  <FormHelperText>{'Please select an option'}</FormHelperText>
                  )}
                  </FormControl>
                  </Grid2>
                ))}
                  <Grid2 size={{ xs: 12, md: 6 }}>
  <Controller
    name={'other'}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <>
        <FormControl fullWidth margin="dense" error={!!error}>
          <FormLabel component="legend">
            Any specific Messages
            {dynamicNote && (
              <Typography
                component="span"
                variant="caption"
                sx={{ fontStyle: 'italic', color: 'text.secondary', ml: 0.5 }}
              >
                ({dynamicNote})
              </Typography>
            )}
            <span style={{ color: 'red' }}> *</span>
          </FormLabel>
          <TextField
            {...field}
            multiline
            minRows={3}
            size="small"
            fullWidth
            error={!!error}
            helperText={error?.message}
          />
        </FormControl>
      </>
    )}
  />
</Grid2>

              </Grid2>
              <Typography variant="body2" color="textSecondary">Note:Fields marked with an asterisk (*) are required.</Typography>

        </StepContainer>
    </form>
  )
});

export default Questionary